export const portfolioTypes = {
  CREDIT_RATING: 'creditRating',
  ESG_ANALYSIS: 'esgAnalysis',
  CREDIT_REVIEW: 'creditReview',
};
